const ElementIds = {
    name: "WholesaleForm-name",
    businessName: "WholesaleForm-business-name",
    email: "WholesaleForm-email",
    phone: "WholesaleForm-phone",
    businessAddress: "WholesaleForm-business-address",
    wholesaleFormError: "wholesale-form_error",
    wholesaleForm: "wholesale-form",
    wholesaleFormSubmitButton: "wholesale__button"
};

const Messages = {
    validation: {
        nameRequired: 'Name is required.',
        businessNameRequired: 'Business name is required.',
        emailRequired: 'Email is required.',
        phoneRequired: 'Phone number is required.',
        businessAddressRequired: 'Business address is required.'
    },
};

const touchedFields = {
    name: false,
    businessName: false,
    email: false,
    phone: false,
    businessAddress: false
};

document.addEventListener('DOMContentLoaded', () => {
    let validationTriggered = false;
    const nameInput = document.getElementById(ElementIds.name);
    const businessNameInput = document.getElementById(ElementIds.businessName);
    const emailInput = document.getElementById(ElementIds.email);
    const phoneInput = document.getElementById(ElementIds.phone);
    const businessAddressInput = document.getElementById(ElementIds.businessAddress);
    const wholesaleFormError = document.getElementById(ElementIds.wholesaleFormError);
    const wholesaleForm = document.getElementById(ElementIds.wholesaleForm);
    const wholesaleFormSubmitButton = document.getElementById(ElementIds.wholesaleFormSubmitButton);
    
    /**
     * 
     * @param {string|undefined} name 
     * @param {Messages|undefined} message
     * @returns {string|undefined} errors
     */
    const validateField = (name, message) => {
        if(name){
            return undefined;
        }
        else{
            return message;
        }
    }

    const validateAndShowErrors = () => {
        const errors = validateForm(false);
        if (errors) {
            showError(errors);
        } else {
            hideError();
        }
    };

    nameInput.addEventListener('input', () => {
        touchedFields.name = true;
        validateAndShowErrors();
    });

    businessNameInput.addEventListener('input', () => {
        touchedFields.businessName = true;
        validateAndShowErrors();
    });

    emailInput.addEventListener('input', () => {
        touchedFields.email = true;
        validateAndShowErrors();
    });

    phoneInput.addEventListener('input', () => {
        touchedFields.phone = true;
        validateAndShowErrors();
    });

    businessAddressInput.addEventListener('input', () => {
        touchedFields.businessAddress = true;
        validateAndShowErrors();
    });

    wholesaleForm.addEventListener('submit', async (e) => {
        wholesaleFormSubmitButton.disabled = true;

        touchedFields.name = true;
        touchedFields.businessName = true;
        touchedFields.email = true;
        touchedFields.phone = true;
        touchedFields.businessAddress = true;

        if (!validationTriggered) {
            validationTriggered = true;
        }
        const errors = validateForm();

        if (errors) {
            e.preventDefault();
            showError(errors);
            return false;
        } else {
            hideError();
        }
        wholesaleFormSubmitButton.disabled = false;
    });

    const hideError = () => {
        wholesaleFormError.textContent = '';
        wholesaleFormError.style.display = 'none';
    };
    /**
     * Method to show an error.
     * @param {string} error
     */
    const showError = (errors) => {
        if (!Array.isArray(errors)) {
            errors = [errors];
        }

        wholesaleFormError.innerHTML = `
            <ul style="margin: 0; padding-left: 1.2em;">
                ${errors.map(err => `<li>${err}</li>`).join('')}
            </ul>
        `;
        wholesaleFormError.style.display = 'block';
    };
    
    /**
     * Method to validate form and return error messages.
     * @returns {string[]|undefined} error messages
     */
    const validateForm = (showAll = false) => {
        const errors = [];
        // const isValid = wholesaleForm.reportValidity();
        const name = nameInput.value;
        const businessName = businessNameInput.value;
        const email = emailInput.value;
        const phone = phoneInput.value;
        const businessAddress = businessAddressInput.value;

        if (showAll || touchedFields.name) {
            const nameError = validateField(name, Messages.validation.nameRequired);
            if (nameError) errors.push(nameError);
        }

        if (showAll || touchedFields.businessName) {
            const businessNameError = validateField(businessName, Messages.validation.businessNameRequired);
            if (businessNameError) errors.push(businessNameError);
        }

        if (showAll || touchedFields.email) {
            const emailError = validateField(email, Messages.validation.emailRequired);
            if (emailError) errors.push(emailError);
        }

        if (showAll || touchedFields.phone) {
            const phoneError = validateField(phone, Messages.validation.phoneRequired);
            if (phoneError) errors.push(phoneError);
        }

        if (showAll || touchedFields.businessAddress) {
            const businessAddressError = validateField(businessAddress, Messages.validation.businessAddressRequired);
            if (businessAddressError) errors.push(businessAddressError);
        }

        if(errors.length){
            return errors
        }
        else{
            return undefined
        }
    }
})
